const mapStyles = [
    {
        elementType: "geometry",
        stylers: [{ color: "#ebe7e1" }]
    },
    {
        elementType: "labels.text.fill",
        stylers: [{ color: "#8f8b86" }]
    },
    {
        elementType: "labels.text.stroke",
        stylers: [{ color: "#f5f1eb" }]
    },
    {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ color: "#ffffff" }]
    },
    {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [{ color: "#7d7d7d" }]
    },
    {
        featureType: "poi",
        stylers: [{ visibility: "off" }]
    },
    {
        featureType: "transit",
        stylers: [{ visibility: "off" }]
    },
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#d8d4cf" }]
    }
];

window.initMap = function () {
    const mapElement = document.getElementById('map');

    if (!mapElement || typeof google === 'undefined') return;

    const lat = parseFloat(mapElement.dataset.lat);
    const lng = parseFloat(mapElement.dataset.lng);

    if (Number.isNaN(lat) || Number.isNaN(lng)) return;

    const position = { lat, lng };

    const map = new google.maps.Map(mapElement, {
        center: position,
        zoom: 15,
        styles: mapStyles,
        disableDefaultUI: false,
        mapTypeControl: false
    });

    new google.maps.Marker({
        position: position,
        map: map,
        icon: {
            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
                    <path fill="#C54228" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                    <circle fill="#ffffff" cx="12" cy="9" r="2.5"/>
                </svg>
            `),
            scaledSize: new google.maps.Size(40, 40),
            anchor: new google.maps.Point(20, 40)
        }
    });
};
